import React from 'react';
import SendReqConfirmModal from './components/send-req-confirm-modal/SendReqConfirm.modal';
import TopDeclaration from './components/TopDeclaration';
import PermitRequestForm from './components/form/PermitRequestForm';
import Page from '../../components/UI/layout/Page';
import PageTitle from '../../components/UI/layout/PageTitle';
import AlertUser from '../../components/Alerts/AlertUser';
import { useGetAPRPAlertState, useSetAPRPAlertState } from '../../stores/add-permit-request-page.store';
import { useTags } from '../../hooks/useTags';
import addRequestPageLang from '../../data/lang/add-request-page.lang';


const PermitRequestPage = () => {

    const alertState = useGetAPRPAlertState();
    const setAlertState = useSetAPRPAlertState();

    const closeAlert = () => setAlertState('noAlert');

    const generateTag = useTags();
    const title = generateTag(addRequestPageLang, 'page-title');


    return (
        <Page
            isLoading={alertState.alertStatus === 'loading'}
            userAlert={<AlertUser state={alertState} onClose={closeAlert} />}
            modals={<SendReqConfirmModal />}
        >
            <div className='container'>
                
                <div className='row'>
                    <div className='col-12'>
                        <PageTitle title={title} withReturnBtn />
                    </div>
                </div>
                
                <div className='row'>
                    <div className='col-12'>
                        <TopDeclaration />
                    </div>
                </div>

                <PermitRequestForm />
            </div>

        </Page>
    );
}

export default PermitRequestPage;